import replyApi from '@/api/reply'

const reply={
  namespaced:true,
  state:{
    data:[],
    loading:false,
    editReply:{},
    sorter:{},
    subscribe:null,
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`}
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    edit:(state,data)=>{
      state.editReply=data
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    },
    setSubscrebe:(state,subscribe)=>{
      state.subscribe=subscribe
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    }
  },
  actions:{
    async GetKeywordReply({ commit },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      try{
        const res=await replyApi.getKeywordReply(page)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async UpdateOrAdd({ commit,dispatch,state },reply){
      try{
        if(reply.id){
          await replyApi.update(reply)          
        }else{
          await replyApi.createReply(reply)
        }
        commit('edit',{})
        await dispatch('GetKeywordReply',state.pagination)
      }catch(err){
        throw err
      }     
    },
    async Delete({ dispatch,state },id){
      await replyApi.delete(id)
      await dispatch('GetKeywordReply',state.pagination)
    },
    async GetSubscribe({ commit }){
      const res=await replyApi.getSubscribe()
      commit('setSubscrebe',res.result)
    }
  }
}
export default reply